<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 14:09:06
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-04-19 16:12:04
-->
<template>
	<el-button
		v-if="!item.tooltipContent"
		:size="size"
		:type="item.buttonType ? item.buttonType : item.type"
		:disabled="item.disabled"
		:plain="item.plain"
		@click="click(item)"
	>
		<div
			:class="[
				!item.disabled &&
					(item.classtype == 1
						? 'yx-color-danger'
						: item.classtype == 2
						? 'yx-color-primary'
						: item.classtype == 3
						? 'yx-color-text-regular'
						: item.classtype == 4
						? 'yx-color-text-placeholder'
						: ''),
				item.notSelf ? 'notSelf' : '',
				item.fontFamily ? 'ff' : '',
			]"
		>
			{{ item.label }}
		</div>
	</el-button>
	<el-tooltip
		v-else
		class="item"
		effect="dark"
		:content="`${item.tooltipContent}` || '仅认领招商可修改'"
		:disabled="!item.disabledTooltip && !item.notSelf"
		placement="left"
		:open-delay="TooltipOpenDelay"
	>
		<div style="display: inline-block" v-if="item.disabled">
			<el-button :type="item.type" disabled :size="size" :plain="item.plain" @click="click(item)">
				<div :class="[item.notSelf ? 'notSelf' : '']">{{ item.label }}</div>
			</el-button>
		</div>
		<el-button v-else :type="item.type" :size="size" :plain="item.plain" @click="click(item)">
			<div :class="[item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '', item.notSelf ? 'notSelf' : '']">
				{{ item.label }}
			</div>
		</el-button>
	</el-tooltip>
</template>
<script>
export default {
	name: 'TextButton',
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		rowIndex: {
			type: Number,
			default: 0,
		},
		row: {
			type: Object,
			default: () => ({}),
		},
		size: {
			type: String,
			default: '',
		},
	},
	methods: {
		click({ click }) {
			click && click(this.row, this.rowIndex);
		},
	},
};
</script>
<style lang="less">
.notSelf {
	color: #ddd !important;
}
.notSelf:hover {
	cursor: default;
	border-bottom: none;
}
.el-button {
	font-weight: normal;
}
.ff {
	font-family: PingFangSC-Regular !important;
}
</style>
